// extracted by mini-css-extract-plugin
module.exports = {"accentuation":"accentuation___FIhwR"};